/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_RequestedInputs */

const en_status_requested = /** @type {(inputs: Status_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requested`)
};

const es_status_requested = /** @type {(inputs: Status_RequestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitado`)
};

/**
* | output |
* | --- |
* | "Requested" |
*
* @param {Status_RequestedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_requested = /** @type {((inputs?: Status_RequestedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_RequestedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_requested(inputs)
	return es_status_requested(inputs)
});